module.exports = __webpack_public_path__ + "img/Lightbulb-Moment_wide_light.ad5b72ca.png";